import Vue from "vue";
import Router from "vue-router";
import store from "./store/index";

// Register Vue Router as a plugin
Vue.use(Router);

// Components
import SignIn from "./views/SignIn.vue";
import SignUp from "./views/SignUp.vue";
import PDFView from "@/components/PDFView.vue";

import Dashboard from "@/components/Dashboard.vue";
import Notification from "@/components/Notification.vue";
import Script from "@/components/Script.vue";
import Statistics from "@/components/Statistics.vue";

import UserList from "@/components/UserList.vue";
import Device from "@/components/Device.vue";
import Group from "@/components/Group.vue";
import Config from "@/components/Config.vue";
import License from "@/components/License.vue";
import Tenant from "@/components/Tenant.vue";
import Kakao from "@/components/Kakao.vue";
import KakaoAuthority from "@/components/KakaoAuthority.vue";
import KakaoGroup from "@/components/KakaoGroup.vue";

// Survey-related components
import SurveyList from "@/components/survey/SurveyList.vue";
import SurveyDetail from "@/components/survey/SurveyDetail.vue";
import SurveyForm from "@/components/survey/SurveyForm.vue";
import SurveyVisualized from "@/components/survey/SurveyVisualized.vue";
import SurveyQuestionnaire from "@/components/survey/SurveyQuestionnaire.vue";

// Chatter-related components
import ChatterList from "@/components/chatter/chat/ChatterList.vue";
import ChatterEdit from "@/components/chatter/chat/ChatterEdit.vue";
import ChatterFileList from "@/components/chatter/fileList/ChatterFileList.vue";
import ChatterProjectList from "@/components/chatter/project/ChatterProjectList.vue";
import ChatterProjectNew from "@/components/chatter/project/ChatterProjectNew.vue";
import ChatterProjectDetail from "@/components/chatter/project/ChatterProjectDetail.vue";
import ChatterSnippetList from "@/components/chatter/code/snippet/ChatterSnippetList.vue";
import ChatterSnippetForm from "@/components/chatter/code/snippet/ChatterSnippetForm.vue";
import ChatterImport from "@/components/chatter/chat/ChatterImport.vue";
// import ChatterHoliday from "@/components/chatter/calendar/ChatterHoliday.vue";
// import ChatterDayOff from "@/components/chatter/calendar/ChatterDayOff.vue";
// import ProjectDashboard from "@/components/chatter/ProjectDashboard.vue"; // 기존 신세계용 ProjectDashboard
import ProjectDashboard from "@/components/chatter/project/Dashboard.vue"; // 기존 ProjectDashboard2
// import ProjectDashboard3 from "@/components/chatter/project/ProjectDashboard3.vue"; // 신세계 테스트 케이스용 ProjectDashboard3
import ChatterMainCalendar from "@/components/chatter/calendar/ChatterMainCalendar.vue";
import MySchedule from "@/components/chatter/MySchedule.vue";
import MyScheduleNew from "@/components/chatter/MyScheduleNew.vue";
import MyScheduleDetail from "@/components/chatter/MyScheduleDetail.vue";
import ProjectWbs from "@/components/chatter/wbs/ProjectWbs.vue";

import PostList from "@/components/board/PostList.vue";
import PostDetail from "@/components/board/PostDetail.vue";

// Requirement List
import RequirementList from "./components/chatter/requirement/RequirementList.vue";
import RequirementDetail from "./components/chatter/requirement/RequirementDetail.vue";

// ESG-related components
// Base Components
import EsgHome from "@/components/esg/base/EsgHome.vue";
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";
import EsgDataIo from "@/components/esg/1. Base Information/EsgDataUpload.vue";

// GHG Monitoring
import EsgGhgEmissionManagementDashboard from "@/components/esg/3. Monitoring/3.1. 온실가스 관리/3.1.0. 대시보드/EsgGhgEmissionManagementDashboard.vue";
import EsgGhgEmissionMgmtByScope from "@/components/esg/3. Monitoring/3.1. 온실가스 관리/3.1.2. 스코프별 배출량 관리/EsgGhgEmissionMgmtByScope.vue";
import EsgGhgEmissionMgmtByOrgs from "@/components/esg/3. Monitoring/3.1. 온실가스 관리/3.1.1. 조직별 배출량 관리/EsgGhgEmissionMgmtByOrgs.vue";
import EsgGhgFirmwideGoalMonitoring from "@/components/esg/3. Monitoring/3.1. 온실가스 관리/3.1.3. 전사 목표 모니터링/EsgGhgFirmwideGoalMonitoring.vue";

// LCA Monitoring
import EsgLcaEmissionAmountManagement from "@/components/esg/3. Monitoring/3.2. LCA 배출량 관리/3.2.0. 대시보드/EsgLcaEmissionAmountManagement.vue";
import EsgLcaGhgEmissionMgmtByProduct from "@/components/esg/3. Monitoring/3.2. LCA 배출량 관리/3.2.1. 제품별/EsgLcaGhgMgmtByProduct.vue";
import EsgLcaEmissionAmountManagementByProcess from "@/components/esg/3. Monitoring/3.2. LCA 배출량 관리/3.2.2. 공정별/EsgLcaEmissionAmountManagementByProcess.vue";

// 온실가스 배출 비용 모니터링
import EsgCarbonNeutralCost from "@/components/esg/3. Monitoring/3.3. 온실가스 비용 모니터링/3.3.1. 탄소중립 비용/EsgCarbonNeutralCost.vue"; //탄소 배출권 비용 모니터링
import EsgCarbonEmissionExpectedPurchaseCost from "@/components/esg/3. Monitoring/3.3. 온실가스 비용 모니터링/3.3.2. 탄소배출권 예상구매 비용/EsgCarbonEmissionExpectedPurchaseCost.vue";

// 모니터링 - 온실가스 관리 - 협력사 모니터링
import EsgPartnerCorpMonitoring from "@/components/esg/3. Monitoring/3.4. 협력사 모니터링/EsgPartnerCorpMonitoring.vue"
import EsgPartnerCorpMonitoringGoalManagement from "@/components/esg/3. Monitoring/3.4. 협력사 모니터링/3.4.1. 목표관리/EsgPartnerCorpMonitoringGoalManagement.vue"
import EsgPartnerCorpMonitoringProgressManagement from "@/components/esg/3. Monitoring/3.4. 협력사 모니터링/3.4.2. 진척관리/EsgPartnerCorpMonitoringProgressManagement.vue"
import EsgPartnerCorpMonitoringAssessmentManagement from "@/components/esg/3. Monitoring/3.4. 협력사 모니터링/3.4.3. 평가관리/EsgPartnerAssessmentMgmt.vue"
import EsgPartnerEmissionMonitoring from "@/components/esg/3. Monitoring/3.4. 협력사 모니터링/3.4.4. 배출량관리/EsgPartnerEmissionMonitoring.vue"
import EsgIndividualPartnerMonitoring from "@/components/esg/3. Monitoring/3.4. 협력사 모니터링/3.4.5. 개별 협력사관리/EsgIndividualPartnerMonitoring.vue"

// 탄소 배출량 계산
import PcfCalculation from "@/components/esg/pcf/PcfCalculation.vue"

// 공시 보고서
import EsgDisclosureList from "@/components/esg/6. ESG 공시보고/6.2. 공시 보고서/EsgDisclosureList.vue";
import EsgDisclosureNew from "@/components/esg/6. ESG 공시보고/6.2. 공시 보고서/EsgDisclosureNew.vue";
import EsgDisclosureDetail from "@/components/esg/6. ESG 공시보고/6.2. 공시 보고서/EsgDisclosureDetail.vue";

// 6.1. 보고서 항목 관리
import EsgDisclosureTemplateList from "@/components/esg/6. ESG 공시보고/6.1. 보고서 항목 관리/EsgDisclosureTemplateList.vue";
import EsgDisclosureTemplateNew from "@/components/esg/6. ESG 공시보고/6.1. 보고서 항목 관리/EsgDisclosureTemplateNew.vue";
import EsgDisclosureTemplateDetail from "@/components/esg/6. ESG 공시보고/6.1. 보고서 항목 관리/EsgDisclosureTemplateDetail.vue";

import EsgDisclosureContentList from "@/components/esg/6. ESG 공시보고/6.3. 공시 보고서 항목/EsgDisclosureContentList.vue";
import EsgDisclosureContentDetail from "@/components/esg/6. ESG 공시보고/6.3. 공시 보고서 항목/EsgDisclosureContentDetail.vue";

import VizInsightDashboard from "@/components/vizInsight/Dashboard.vue";
import FlexibleTable from "./components/chatter/customTable/FlexibleTable.vue";
import MemberManagmentDashboard from "./components/chatter/ABC/회원관리/MemberManagmentDashboard.vue";
import PointManagmentDashboard from "./components/chatter/ABC/포인트관리/PointManagmentDashboard.vue";
import CouponManagmentDashboard from "./components/chatter/ABC/쿠폰관리/CouponManagmentDashboard.vue";
import GradeManagmentDashboard from "./components/chatter/ABC/회원등급관리/GradeManagmentDashboard.vue";
import StampManagmentDashboard from "./components/chatter/ABC/스탬프관리/StampManagmentDashboard.vue";

// Global variable
const status = store.state.auth.status;

// Util functions
const getUser = function() {
  return store.getters['auth/currentUser'] || JSON.parse(localStorage.getItem('user'))
}
const roles = function () {
  let user = getUser();
  return user ? user.roles : [];
};

const hasAnyRole = function (...parms) {
  return parms.some((parm) => roles().includes(parm));
};

const authorizeBeforeEnter = function (from, to, next, ...roles) {
  // Authorize
  if (hasAnyRole(...roles)) {
    status.authorized = true;
  }

  if (status.authorized) {
    // Case 1 - Authorized
    next();
  } else {
    // Case 2 - Authenticated but not authorized
    store.commit('setMessage', '접근 권한이 없습니다. 담당자에게 권한을 요청해주세요.')

    if (hasAnyRole("Supervisor", "Administrator", "Operator")) {
      next("/dashboard");
    } else if (hasAnyRole("Surveyor")) {
      next("/survey");
    } else if (hasAnyRole("Chatterer")) {
      next("/chatter");
    } else if (hasAnyRole("ESG")) {
      next("/esg");
    } else {
      next("/signin")
    }
  }
};

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/signin",
      name: "signin",
      component: SignIn,
    },
    {
      path: "/signup",
      name: "signup",
      component: SignUp,
    },
    {
      path: "/pdf-view/:fileName",
      name: "pdf-view",
      component: PDFView,
      props: true,
    },
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
      redirect: (to) => {
        // Get user information
        let user = getUser();

        // Redirect based on the user's preferred role
        if (user && user.preferRole) {
          let preferredRole = user.preferRole;
          if (!hasAnyRole(preferredRole)) return '/dashboard';
          if (preferredRole === 'Administrator') {
            return '/admin';
          } else if (preferredRole === 'Surveyor') {
            return '/survey';
          } else if (preferredRole === 'Chatterer') {
            return '/chatter';
          } else if (preferredRole === 'ESG') {
            return '/esg';
          } else {
            return '/dashboard';
          }
        } else if (user) {
          if (hasAnyRole('Supervisor', 'Administrator')){
            return '/admin';
          } else if (hasAnyRole('Surveyor')) {
            return '/survey';
          } else if (hasAnyRole('Chatterer')) {
            return '/chatter';
          } else if (hasAnyRole('ESG')) {
            return '/esg';
          } else {
            return '/dashboard';
          }
        } else {
          return '/signin';
        }
      },
      children: [
        {
          path: "dashboard",
          component: Dashboard,
        },
        {
          path: "notification",
          component: Notification,
        },
        {
          path: "script",
          component: Script,
        },
        {
          path: "statistics",
          component: Statistics,
        },
      ],
      beforeEnter(to, from, next) {
        authorizeBeforeEnter(to, from, next, "Operator", "Administrator", "Supervisor");
      },
    },
    {
      path: "/survey",
      component: () => import("./views/Survey.vue"),
      children: [
        {
          path: "",
          component: SurveyList,
        },
        {
          path: "new",
          component: SurveyForm,
        },
        {
          path: ":id",
          name: "surveyDetail",
          component: SurveyDetail,
          props: true,
        },
        {
          path: ":id/visualize",
          name: "surveyVisualized",
          component: SurveyVisualized,
          props: true,
        },
        {
          path: ":id/visualize/:secret",
          name: "surveyVisualizedSecret",
          component: SurveyVisualized,
          props: true,
        },
        {
          path: "questionnaire/:id/:secret",
          name: "surveyQuestionnaire",
          component: SurveyQuestionnaire,
          props: true,
        },
      ],
      beforeEnter(to, from, next) {
        authorizeBeforeEnter(to, from, next, "Surveyor");
      },
    },
    {
      path: "/admin",
      redirect: "/admin/user",
      name: "admin",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/Admin.vue"),
      children: [
        {
          path: "user",
          component: UserList,
        },
        {
          path: "device",
          component: Device,
        },
        {
          path: "group",
          component: Group,
        },
        {
          path: "config",
          component: Config,
        },
        {
          path: "license",
          component: License,
        },
        {
          path: "tenant",
          component: Tenant,
        },
        {
          path: "kakao",
          component: Kakao,
        },
        {
          path: "kakaoAuthority",
          component: KakaoAuthority,
        },
        {
          path: "kakaoGroup",
          component: KakaoGroup,
        },
      ],
      beforeEnter(to, from, next) {
        authorizeBeforeEnter(to, from, next, "Administrator", "Supervisor");
      },
    },
    {
      path: "/chatter",
      component: () => import("./views/Chatter.vue"),
      children: [
        {
          path: "",
          component: ChatterList,
        },
        {
          path: "board",
          component: PostList
        },
        {
          path: "post-detail/:id?",
          name: "postDetail",
          component: PostDetail,
          props: true
        },
        // {
        //   path: "post-detail",
        //   component: PostDetail,
        // },
        {
          path: "chatter-project-list",
          component: ChatterProjectList,
        },
        // {
        //   path: "project-dashboard",
        //   component: ProjectDashboard,
        // },
        {
          path: "dashboard",
          component: ProjectDashboard,
        },
        // {
        //   path: "project-dashboard3",
        //   component: ProjectDashboard3,
        // },
        {
          path: "chatter-project-new",
          component: ChatterProjectNew,
        },
        {
          path: "wbs",
          name : "projectWbs",
          component:ProjectWbs
        },
        // {
        //   path: "new",
        //   name: "newChat",
        //   component: ChatterNew,
        //   props: true
        // },
        {
          path: "import",
          component: ChatterImport
        },
        /* 24-02-23 yhkim@hiaas.co.kr 
           Todo List의 기능이 완성되기 전까지 숨김 처리
        */
        // {
        //   path: "my-schedule",
        //   name: "mySchedule",
        //   component: MySchedule,
        // },
        // {
        //   path: "my-schedule-new",
        //   name: "myScheduleNew",
        //   component: MyScheduleNew,
        //   props: true
        // },
        {
          path: "code/snippets",
          component: ChatterSnippetList
        },
        {
          path: "code/snippets/form",
          component: ChatterSnippetForm,
          props: (route) => ({
            tenantId: route.query.tenantId,
            processName: route.query.processName,
            version: route.query.version
          })
        },
        // {
        //   path: "chatter-holiday",
        //   name: "chatterHoliday",
        //   component: ChatterHoliday,
        // },        
        {
          path: "chatter-main-calendar",
          name: "chatterMainCalendar",
          component: ChatterMainCalendar,
        },
        // {
        //   path: "chatter-day-off",
        //   name: "chatterDayOff",
        //   component: ChatterDayOff,
        // },
        {
          path: "files",
          name: "chatterFileList",
          component: ChatterFileList,
        },
        {
          path: "import",
          name: "chatterImport",
          component: ChatterImport
        },
        {
          path: "edit",
          name: "chatCreate",
          component: ChatterEdit,
          props: true,
        },
        {
          path: "edit/:id",
          name: "chatUpdate",
          component: ChatterEdit,
          props: true,
        },
        {
          path: "my-schedule/:id",
          name: "myScheduleDetail",
          component: MyScheduleDetail,
          props: true,
        },
        {
          path: "project/:id",
          name: "projectDetail",
          component: ChatterProjectDetail,
          props: true,
        },
        {
          path: "requirement-list",
          name: "requirementList",
          component: RequirementList,
        },
        {
          path: "requirement",
          name: "requirementCreate",
          component: RequirementDetail,
          props: true,
        },
        {
          path: "requirement/:id",
          name: "requirementDetail",
          component: RequirementDetail,
          props: true,
        },
        {
          path: "poc",
          name: "pocDashboard",
          component: VizInsightDashboard,
        },
        {
          path: "flexible-table",
          name: "FlexibleTable",
          component: FlexibleTable,
        },
        {
          path: "member-management",
          name: "MemberManagementDashboard",
          component: MemberManagmentDashboard
        },
        {
          path: "point-management",
          name: "PointManagementDashboard",
          component: PointManagmentDashboard
        },
        {
          path: "coupon-management",
          name: "CouponManagementDashboard",
          component: CouponManagmentDashboard
        },
        {
          path: "grade-management",
          name: "GradeManagementDashboard",
          component: GradeManagmentDashboard
        },
        {
          path: "stamp-management",
          name: "StampManagementDashboard",
          component: StampManagmentDashboard
        }

      ],
      beforeEnter(to, from, next) {
        authorizeBeforeEnter(to, from, next, "Chatterer");
      },
    },
    {
      path: "/esg",
      component: () => import("./views/Esg.vue"),
      children: [
        {
          path: "",
          redirect: "home",
        },
        {
          path: "home",
          component: EsgHome
        },
        {
          path: "ghg-emission-amount-management",
          component: EsgGhgEmissionManagementDashboard
        },
        {
          path: "ghg-emission-amount-management-by-organization",
          component: EsgGhgEmissionMgmtByOrgs,
        },
        {
          path: "ghg-emission-amount-management-by-scope",
          component: EsgGhgEmissionMgmtByScope
        },
        {
          path: "ghg-firmwide-goal-monitoring",
          component: EsgGhgFirmwideGoalMonitoring
        },
        {
          path: "lca-emission-amount-management",
          component: EsgLcaEmissionAmountManagement
        },
        {
          path: "lca-emission-amount-management-by-product",
          component: EsgLcaGhgEmissionMgmtByProduct,
        },
        {
          path: "lca-emission-amount-management-by-process",
          component: EsgLcaEmissionAmountManagementByProcess
        },
        {
          path: "carbon-neutral-cost",
          component: EsgCarbonNeutralCost
        },
        {
          path : "carbon-emission-expected-purchase-cost",
          component: EsgCarbonEmissionExpectedPurchaseCost
        },
        {
          path: "partner-corp-monitoring",
          component: EsgPartnerCorpMonitoring
        },
        {
          path: "partner-corp-monitoring-goal-management",
          component: EsgPartnerCorpMonitoringGoalManagement
        },
        {
          path: "partner-corp-monitoring-progress-management",
          component: EsgPartnerCorpMonitoringProgressManagement
        },
        {
          path: "partner-corp-monitoring-assessment-management",
          component: EsgPartnerCorpMonitoringAssessmentManagement
        },
        {
          path: "partner-corp-monitoring-emission-amount-management",
          component: EsgPartnerEmissionMonitoring
        },
        {
          path: "partner-corp-monitoring-by-corp",
          component: EsgIndividualPartnerMonitoring
        },
        {
          path: "pcf-calculation",
          component: PcfCalculation,
        },
        {
          path: "data-io",
          component: EsgDataIo,
        },
        {
          path: "tables/:name",
          component: EsgBaseList,
          props: true,
        },

        // 공시 보고서 관련 라우트
        {
          path : "disclosures",
          component: EsgDisclosureList
        },
        {
          path : "disclosures/new",
          component : EsgDisclosureNew
        },
        {
          path : "disclosure-templates",
          component : EsgDisclosureTemplateList
        },
        {
          path : "disclosure-templates/new",
          component : EsgDisclosureTemplateNew
        },
        {
          path : "disclosure-templates/:id",
          name : "disclosureTemplateDetail",
          component : EsgDisclosureTemplateDetail,
          props: true,
        },
        {
          path : "disclosure/:id",
          name : "disclosureDetail",
          component : EsgDisclosureDetail,
          props: true,
        },
        {
          path : "report/contents",
          name: "EsgDisclosureContentList",
          component: EsgDisclosureContentList
        },
        {
          path : "report/contents/:id",
          name: "EsgDisclosureContentDetail",
          component: EsgDisclosureContentDetail,
          props: true,
        },
      ],
      beforeEnter(to, from, next) {
        authorizeBeforeEnter(to, from, next, "ESG");
      },
    },
    {
      path: "*",
      redirect: "dashboard",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // Authorize if the destination page is public
  const publicPages = ["signin", "signup", "surveyVisualizedSecret", "surveyQuestionnaire"];
  status.authorized = publicPages.includes(to.name);

  // Authenticate user info and JWT
  if (!status.authorized) {
    await store.dispatch('auth/authenticate');
  }

  if (status.authorized || status.authenticated) {
    // If authorized or authenticated, proceed
    if(to.path === "/chatter" || to.path === "/chatter/" ) {
      let user = getUser();
      if(user && user.caller === 'member@abcmart.com') {
        next('/chatter/member-management');
      }
    }

    next();
  } else {
    // Else, set referrer
    store.commit('auth/setReferrer', to.path);

    // If the user entered specific URL, set message
    if (to.redirectedFrom !== '/') {
      store.commit('setMessage', '접근 권한이 없습니다. 먼저 로그인을 해주세요.');
    }

    // Redirect to login page
    next("/signin");
  }
});

export default router;
